import { AfterViewInit, Component, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { InceptedApeByAdvisors } from '../../dashboard-interfaces/incepted-ape-by-advisors.interface';
import { DashboardManagerTeamService } from '../../dashboard-services/dashboard-manager-team/dashboard-manager-team.service';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { HttpStatusCode } from 'axios';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-incepted-ape-manager-advisors',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ReactiveFormsModule,
    MatDividerModule
  ],
  templateUrl: './view-incepted-ape-manager-advisors.dialog.html',
  styleUrl: './view-incepted-ape-manager-advisors.dialog.scss'
})
export class ViewInceptedApeManagerAdvisorsDialog implements OnInit, AfterViewInit {

  private router = inject(Router);
  private snackBarService = inject(SnackbarService);
  private dashboardManagerTeamService = inject(DashboardManagerTeamService);

  private inceptedApeByAdvisorData: InceptedApeByAdvisors[] = [];
  protected inceptedApeByAdvisorTableDisplayDataRow: string[] = ["repCode", "personName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
  protected inceptedApeByAdvisorTableDisplayFirstColumn: string[] = ['repCode', 'personName', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
  protected inceptedApeByAdvisorTableDisplaySecondColumn: string[] = ['monthSinglife', 'monthSinglifeCase', 'monthNonsinglife', 'monthNonsinglifeCase', 'yearSinglife', 'yearSinglifeCase', 'yearNonsinglife', 'yearNonsinglifeCase'];
  protected inceptedApeByAdvisorTableDataSource = new MatTableDataSource<InceptedApeByAdvisors>();

  inceptedApeBranchAdvisorTableFilterFc = new FormControl("");

  @ViewChild('inceptedApeByAdvisorTablePaginator')
  inceptedApeByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByAdvisorTableSort')
  inceptedApeByAdvisorTableSort = new MatSort();

  protected managerRepCode: string = "";
  protected managerName: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public matData: any
  ) { }

  async ngOnInit(): Promise<void> {
    this.managerRepCode = this.matData.managerRepCode;
    this.managerName = this.matData.managerName;

    await this.getDashboardDataByBranchAdvisors(this.managerRepCode);

    this.inceptedApeByAdvisorTableDataSource.data = this.inceptedApeByAdvisorData;
  }

  ngAfterViewInit(): void {
    this.inceptedApeByAdvisorTableDataSource.paginator = this.inceptedApeByAdvisorTablePaginator;
    this.inceptedApeByAdvisorTableDataSource.sort = this.inceptedApeByAdvisorTableSort;
  }

  private async getDashboardDataByBranchAdvisors(managerRepCode: string) {
    const responseData = await this.dashboardManagerTeamService
      .getDashboardInceptedApeManagerwiseAdvisors(managerRepCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      const advisorData: any[] = responseData.data.responsedata;
      advisorData.forEach((advisorItem) => {
        this.inceptedApeByAdvisorData.push({
          repCode: advisorItem.piasRepCode.toString(),
          personName: advisorItem.agentRealName.toString() || advisorItem.agentPreferredName.toString(),
          branch: advisorItem.branch.toString(),
          monthSinglife: Number.parseInt(advisorItem.mtdSinglife.toString()),
          monthSinglifeCase: Number.parseInt(advisorItem.mtdSinglifeCase.toString()),
          monthNonsinglife: Number.parseInt(advisorItem.mtdNonSinglife.toString()),
          monthNonsinglifeCase: Number.parseInt(advisorItem.mtdNonSinglifeCase.toString()),
          yearSinglife: Number.parseInt(advisorItem.ytdSinglife.toString()),
          yearSinglifeCase: Number.parseInt(advisorItem.ytdSinglifeCase.toString()),
          yearNonsinglife: Number.parseInt(advisorItem.ytdNonSinglife.toString()),
          yearNonsinglifeCase: Number.parseInt(advisorItem.ytdNonSinglifeCase.toString()),
          yearTarget: 0,
          yearTotal: (Number.parseInt(advisorItem.ytdSinglife.toString()) + Number.parseInt(advisorItem.ytdNonSinglife.toString())),
          userGroup: advisorItem.userGroup.toString()
        });
      });
      
      // this.inceptedApeByAdvisorData = this.inceptedApeByAdvisorData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Something went wrong!!!");
      }
      if(responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  protected clearSearchField() {
    this.inceptedApeBranchAdvisorTableFilterFc.setValue('');
    this.__applyInceptedApeBranchAdvisorsDataFilter();
  }

  protected __applyInceptedApeBranchAdvisorsDataFilter() {
    let filterValue: string = this.inceptedApeBranchAdvisorTableFilterFc.value?.toString() || '';

    let tempInceptedApeByAdvisorTableData: InceptedApeByAdvisors[] = [];

    if (filterValue) {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData.filter(apeData =>
        apeData.repCode.toString().includes(filterValue)
        || apeData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData;
    }

    this.inceptedApeByAdvisorTableDataSource.data = tempInceptedApeByAdvisorTableData;
  }

}
